import { useState } from "react";
import { DiscreteInputBase, Props } from "./DiscreteInput.Parts";

export const DiscreteInput = ({
  expectedLength,
  normalize = (v) => v,
  value,
  setValue,
  ...rest
}: Props) => {
  const [internalValue, setInternalValue] = useState<
    [number | undefined, string | undefined]
  >([undefined, undefined]);

  return (
    <DiscreteInputBase
      {...rest}
      value={value === internalValue[0] ? internalValue[1] : value}
      $expectedLength={expectedLength}
      onChange={(e) => {
        const parsedNumber = parseFloat(e.target.value || "0");
        const numericValue = isNaN(parsedNumber)
          ? internalValue[0]
          : normalize(parsedNumber);

        setInternalValue([numericValue, e.target.value]);
        if (!isNaN(parsedNumber)) {
          setValue?.(normalize(parsedNumber));
        }
      }}
      onBlur={() => {
        setInternalValue([undefined, undefined]);
      }}
    />
  );
};
